var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404")]),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Go back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }